const LoggedOutPage = () => (
  <p>
    Log in to Duolingo at <a href="https://www.duolingo.com">duolingo.com</a> to
    get started!
  </p>
);
export default LoggedOutPage;
